import { ActionMenuItem } from "components/personnelAndFleet/common/ActionCell";
import { PersonnelUser } from "models/PersonnelUser";

export function getStatusRank(row: PersonnelUser): number {
	if (!row.cvWhenApproved) {
		return 0; // Pending Approval
	}

	if (row.active !== true) {
		return 1; // Deactivated
	}

	return 2; // Active
}

export type PersonnelUserActionHandlers = {
	onEditUser: (user: PersonnelUser) => void;
	onDuplicateUser: (user: PersonnelUser) => void;
	onDeactivateUser: (user: PersonnelUser) => void;
	onActivateUser: (user: PersonnelUser) => void;
	onApproveUser: (user: PersonnelUser) => void;
};

export function getPersonnelUserActionItems(
	user: PersonnelUser,
	handlers: PersonnelUserActionHandlers
): ActionMenuItem[] {
	const isApproved = !!user.cvWhenApproved;
	const isActive = user.active === true;

	return [
		...(isApproved
			? [
					{ label: "Edit", onClick: () => handlers.onEditUser(user) },
					{ label: "Duplicate", onClick: () => handlers.onDuplicateUser(user) }
				]
			: []),
		!isApproved
			? { label: "Approve", onClick: () => handlers.onApproveUser(user) }
			: isActive
				? { label: "Deactivate", onClick: () => handlers.onDeactivateUser(user), isDanger: true }
				: { label: "Activate", onClick: () => handlers.onActivateUser(user) }
	];
}
